import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Seo from "@/components/Seo";

export default function Login() {
  const { login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email, password);
    setBusy(false);
    if (ok) navigate("/feed");
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-12">
      <Seo
        title="Sign in · Jesus Just Us"
        description="Sign in to Jesus Just Us — a Christian community for prayer, testimonies, worship, and walking with believers."
        path="/login"
        noindex
      />
      <div className="w-full max-w-md jj-card p-8 sm:p-10 fade-up">
        <div className="overline text-burgundy">Welcome back</div>
        <h1 className="font-serif text-4xl text-jjblue mt-2">Sign in</h1>
        <p className="mt-2 text-[var(--jj-text-secondary)] text-sm">Step back into the community.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="text-sm text-jjblue/80">Email</label>
            <input className="input-jj mt-1" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
          </div>
          <div>
            <label className="text-sm text-jjblue/80">Password</label>
            <input className="input-jj mt-1" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          </div>
          {error && <div className="text-sm text-[var(--jj-burgundy)]" data-testid="login-error">{error}</div>}
          <button disabled={busy} className="btn-primary w-full" data-testid="login-submit">{busy ? "Signing in…" : "Sign in"}</button>
        </form>
        <p className="mt-4 text-sm text-center">
          <Link to="/forgot-password" className="text-[var(--jj-text-secondary)] hover:text-burgundy" data-testid="login-forgot">Forgot your password?</Link>
        </p>
        <p className="mt-6 text-sm text-[var(--jj-text-secondary)]">
          New here? <Link to="/register" className="text-burgundy font-medium">Join the community</Link>
        </p>
      </div>
    </div>
  );
}
